import Collection from '../../../../collection/Collection';
import { RamqSpecialistActCodeNatureType } from '../../../../medyx-core/types/ramq';
import { ActCode } from './Act';

class ActCodes extends Collection<ActCode> {
  public isContainsSome(...codes: string[]): boolean {
    return this.data.some(({ code }) => codes.includes(code));
  }

  public isContainsPdt(): boolean {
    return this.data.some(({ natureType }) => natureType === RamqSpecialistActCodeNatureType.PDT);
  }
}

export default ActCodes;
